import ButtonProps from 'components/Button'
import styled from 'styled-components'

export const Button = styled(ButtonProps)`
  width: 100%;
  white-space: nowrap;
  margin-bottom: 0;
  margin-left: ${({ theme }) => theme.spacing(1)}px;
`
